<template>
  <div class="view marketing recipients">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3"><strong>Recipient Group</strong></h3>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">All Recipients ({{ groups.length || 0 }})</h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <span>
                <a-button type="primary" icon="plus" @click="onCreateGroup"> Create Group </a-button>
              </span>
            </div>
          </div>
          <div class="wrap">
            <!-- selector -->
            <div style="background-color: #ececec; padding: 20px">
              <a-row :gutter="[16, 16]">
                <a-col :span="8" v-for="group in groups" :key="group._id">
                  <a-card hoverable :title="group.name" :bordered="false" @click="onEditGroup(group._id)">
                    <span slot="extra" href="#">{{ group.recipients.length || 0 }} Recipients</span>
                    <img slot="cover" alt="cover" src="/resources/images/email-bg.png" />
                    <template slot="actions" class="ant-card-actions">
                      <a-icon key="setting" type="setting" />
                      <a-icon key="edit" type="edit" />
                      <a-icon key="ellipsis" type="ellipsis" />
                    </template>

                    <a-card-meta>
                      <a-avatar slot="avatar" icon="user" />
                      <span slot="title">{{ group.name }}</span>
                      <div slot="description">
                        <p>
                          {{ group.description }}
                        </p>
                        <a-tag color="blue" v-if="group.created_at"
                          >Created {{ group.created_at | moment('from') }}</a-tag
                        >
                        <a-tag color="green" v-if="group.updated_at"
                          >Updated {{ group.updated_at | moment('from') }}</a-tag
                        >
                      </div>
                    </a-card-meta>
                  </a-card>
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const KEY = 'recipient_groups'

export default {
  data() {
    return {
      key: 'xxx',
    }
  },
  computed: {
    groups() {
      return this.$store.getters['marketing/data'](KEY) || []
    },
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('marketing/fetchRecipientGroups')
    },

    onCreateGroup() {
      this.$router.push(`/marketing/recipients/create`)
    },

    onEditGroup(id) {
      this.$router.push(`/marketing/recipients/edit/${id}`)
    },
  },

  async created() {
    await this.fetch()
  },
}
</script>

<style lang="scss" scoped></style>
